import React, {useState} from 'react'
import {updateCategory, getCategoryById} from "../../services/serviceCategory";
import {getAllBrand} from "../../services/serviceBrand";
import {AutoComplete, Button, Form, Input, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const { TextArea } = Input
const { Option } = AutoComplete
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const CategoryEdit = ({category, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [createdBrand, setCreatedBrand] = useState()
    const [brands, setBrands] = useState([])
    const [loadings, setLoadings] = useState([])


    const handleEditClick = () => {
        getCategoryById(category.id)
            .then(({data}) => {
                form.setFieldsValue({
                    categoryName: data.name,
                    categoryCode: data.code,
                    categoryDescription: data.description,
                    categoryBrand: data.brand.code
                })
                setCreatedBrand(data.brand.id)
            })
        getAllBrand()
            .then(({data}) => {
                let brandsData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.name
                    }
                    brandsData.push(pushObj)
                })
                setBrands(brandsData)
            })
        setEditModal(!editModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.categoryName,
            code: list.categoryCode,
            description: list.categoryDescription,
            brandId: createdBrand,
            id: category.id
        }
        updateCategory(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    const handleBrandChange = (value, option) => {
        setCreatedBrand(option.key)
    }

    return(
        <React.Fragment>
            <Button type={'link'} onClick={()=>handleEditClick()}>Güncelle</Button>

            <Modal
                open={editModal}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={()=> form.submit()}>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue()) }
                >
                    <Form.Item
                        label={'Kategori Adı'}
                        name={'categoryName'}
                        rules={[
                            {required:true, message: 'Kategori Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Kategori Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />

                    </Form.Item>

                    <Form.Item
                        label={'Kategori Kodu'}
                        name={'categoryCode'}
                        rules={[
                            {required: true, message: 'Kategori Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Kategori Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Kategori Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={'Marka'}
                        name={'categoryBrand'}
                        rules={[
                            {required: true, message: 'Lütfen Bir Marka Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleBrandChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {brands.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>

                    <Form.Item
                        label={'Kategori Açıklaması'}
                        name={'categoryDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default CategoryEdit